export const MenuType = {
  "DEFAULT": 0,
  "POPUP": 1,
  "EMBEDDED": 2,
  "DONATION": 3,
  "ECOMMERCE": 4,
  "PRE_PACKAGED": 5,
  "ESSENTIALS": 6
}